import type { SponsorshipPointsScale } from "@/features/sponsorship/types/sponsorship.type";

// Derniers recours alignés sur le règlement Programme Yeati Blue, utilisés
// tant qu'aucune version du règlement n'est publiée par l'API. Une fois le
// règlement publié, le barème réel (base) prend le relais partout.
export const DEFAULT_POINTS_SCALE: SponsorshipPointsScale = {
  cse_qualifie: 1000,
  rdv_confirme: 1000,
  signe: 13000,
};

export const DEFAULT_POINTS_PER_EURO = 100;
